var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.99935L7.5 9.99935M17.5 4.99935L7.5 4.99935M17.5 14.9994L7.5 14.9993M4.16667 9.99935C4.16667 10.4596 3.79357 10.8327 3.33333 10.8327C2.8731 10.8327 2.5 10.4596 2.5 9.99935C2.5 9.53911 2.8731 9.16602 3.33333 9.16602C3.79357 9.16602 4.16667 9.53911 4.16667 9.99935ZM4.16667 4.99935C4.16667 5.45959 3.79357 5.83268 3.33333 5.83268C2.8731 5.83268 2.5 5.45959 2.5 4.99935C2.5 4.53911 2.8731 4.16602 3.33333 4.16602C3.79357 4.16602 4.16667 4.53911 4.16667 4.99935ZM4.16667 14.9993C4.16667 15.4596 3.79357 15.8327 3.33333 15.8327C2.8731 15.8327 2.5 15.4596 2.5 14.9993C2.5 14.5391 2.8731 14.166 3.33333 14.166C3.79357 14.166 4.16667 14.5391 4.16667 14.9993Z",
    stroke: "#2A2B28",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.3aef9cdcb6e838ee138a4af6a4d8d497.svg";
export { ForwardRef as ReactComponent };